/*
front end mapping for feature flags
pattern we use is feature.function.state ie. metadoc.move.enabled
*/
export const FEATURE_FLAGS = {
  // section 111
  S111_DASHBOARD_ENABLED: "section111.enable_dashboard",

  // metadoc
  METADOC_ENABLED: "enable_metadoc", // enable metadoc feature set
  METADOC_MOVE_ENABLED: "metadoc.move.enabled", // enable metadoc move feature (toolbar)
  METADOC_DELETE_ENABLED: "metadoc.delete.enabled", // enable metadoc delete feature (toolbar)
  METADOC_SEARCH_ENABLED: "metadoc.search.enabled", // enable metadoc search feature (toolbar + hotkey)
  METADOC_OPS_SEARCH_ENABLED: "metadoc.ops_search.enabled",
  METADOC_FILTER_ENABLED: "metadoc.filter.enabled", // enable metadoc toc filter control (toolbar)
  METADOC_ZOOM_ENABLED: "metadoc.zoom.enabled", // enable metadoc zoom controls (toolbar + hotkey)
  METADOC_POST_AI_ENABLED: "metadoc.post_ai.enabled", // enable metadoc post ai functionality (sorted TOC)
  METADOC_CLONING_ENABLED: "metadoc.cloning.enabled", // enable cloning workflow for an existing metadoc cloned for ai analysis
  METADOC_SUMMARIES_METADATA_ENABLED: "metadoc.summaries-metadata.enabled", // enable metadoc summaries metadata tabs/workspace flow
  METADOC_RATED_AGE_REQUEST_ENABLED: "metadoc.rated_age_request.enabled", // enable Records for Rated Age tag assignment + the per-row tag button
  METADOC_FROI_AND_CMS_SUBMISSION_TAGS_ENABLED:
    "metadoc.froi_and_cms_submission_tags.enabled",
  METADOC_CMS_SUBMISSION_DATE_RANGE_TAGGING_ENABLED:
    "metadoc.cms_submission_date_range_tagging.enabled",

  // modal ai service
  MODAL_AI_SERVICE_ENABLED: "modal_ai_service_enabled",

  // documents
  PRESIGNED_DRAWER_UPLOAD_ENABLED: "documents.enable_presigned_drawer_upload", // route documents-drawer uploads through presigned S3 URLs
  PRESIGNED_URL_PREVIEWS_ENABLED: "core.enable_presigned_url_previews", // serve document previews via presigned S3 URLs instead of streaming through the app server

  // metadoc lazy updates
  METADOC_LAZY_UPDATES_ENABLED: "metadoc.lazy_updates.enabled", // batch category/date changes and apply on demand instead of triggering regeneration on each edit

  // reporting
  LIBERTY_SUPPLIER_REPORT_ENABLED:
    "reporting.is_liberty_supplier_report_enabled", // gate viewing/generating the Liberty Mutual supplier report

  // operations
  LIBERTY_REFERRAL_FIELDS_ENABLED: "operations.enable_liberty_referral_fields", // gate the 5 Liberty Mutual referral fields plus claim_notes on intake + Operations + Medical Review
  RATED_AGE_REQUEST_ENABLED: "operations.enable_rated_age_request", // gate the manual rated age request button + modal on the Operations file view
  REQUEST_FOR_MATERIALS_EMAIL_ENABLED:
    "operations.enable_request_for_materials_email",

  // future medical
  RATED_AGE_OCR_ENABLED: "future_medical.enable_rated_age_ocr", // gate the OCR Rated Age button + modal on the MSA/CostProjection rated age page
  MSA_DECISION_OCR_ENABLED: "future_medical.enable_msa_decision_ocr", // gate the OCR CMS decision letter upload button on the cms-status page
  MSA_DEVELOPMENT_OCR_ENABLED: "future_medical.enable_msa_development_ocr", // gate the OCR CMS development letter upload button on the cms-status page
  CMS_SUBMISSION_BUILDER_ENABLED:
    "future_medical.enable_cms_submission_builder", // single switch for the whole Submission Builder widget on the MSA / Amended Review CMS Submission tab

  // intake
  REFERRAL_ACKNOWLEDGEMENT_EMAIL_ENABLED:
    "intake.enable_referral_acknowledgement_email", // gate the auto and manual referral acknowledgement email sends

  DOCUMENTS_MULTI_SELECT_ENABLED: "documents.multi_select.enabled",

  OPERATIONS_LETTER_GENERATION_ENABLED:
    "document_generation.enable_operations_letter_generation",
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
